/**
 * AppPermissionsRiskGauge: Guardian's 0-100 risk score for an OAuth app as a
 * Carbon progress bar (blueprint §4.5, `ProgressBar` replaces the gauge): the
 * label names the score, the 8px bar fills in the strong neutral, and the
 * helper names the tier with its severity shape. Only a Critical tier takes a
 * hue, on the glyph (DESIGN.md "The Shape-First Severity Rule"). Props are
 * unchanged.
 */
import { ProgressBar } from '@/components/carbon/ProgressBar'
import { SeverityGlyph } from '@/components/carbon/SeverityGlyph'
import { severityFromApi } from '@/components/carbon/severity'

interface AppPermissionsRiskGaugeProps {
  score: number | null
  tier: string
}

export function AppPermissionsRiskGauge({ score, tier }: AppPermissionsRiskGaugeProps) {
  if (score === null) return null
  const scorePercent = Math.round(score * 100)

  return (
    <ProgressBar
      value={scorePercent}
      max={100}
      label={
        <span>
          Risk score <b className="font-semibold tabular-nums">{scorePercent}</b>
          <span className="text-text-helper"> of 100</span>
        </span>
      }
      helper={
        <SeverityGlyph level={severityFromApi(tier)} size={12}>
          {tier} risk tier
        </SeverityGlyph>
      }
    />
  )
}
